import React, { useContext } from 'react';
import EmailsModule from '../../emails';
import ModalModule from '../../modal';

const { Modal, ModalContext, ModalButtonActionType } = ModalModule;
const { Emails } = EmailsModule;

const ShipNotificationModal = ({ modalId }) => {
	const { closeModal } = useContext(ModalContext);

	const closeShipNotificationModal = () => {
		closeModal(modalId, ModalButtonActionType.Ok);
	};

	return (
		<Modal
			className="common-settings ship-notification-modal"
			modalId={modalId}
			header="Ship Notification Email"
			hideFooter
		>
			<Emails completionCallback={closeShipNotificationModal} />
		</Modal>
	);
};

export default ShipNotificationModal;
